import { render, staticRenderFns } from "./DiseaseInfoAddEdit.vue?vue&type=template&id=c8fbe832&"
import script from "./DiseaseInfoAddEdit.vue?vue&type=script&lang=js&"
export * from "./DiseaseInfoAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseInfoAddEdit.vue?vue&type=style&index=0&id=c8fbe832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports